import React, { createContext, useContext, useState } from "react";
import { Snackbar, Alert } from "@mui/material";

const SnackbarContext = createContext();

export const SnackbarProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [autoHideDuration, setAutoHideDuration] = useState(3000);

  const showSnackbar = (msg, options = {}) => {
    setMessage(msg);

    if (typeof options === "string") {
      setSeverity(options);
      setAutoHideDuration(3000);
    } else if (typeof options === "object") {
      setSeverity(options.severity || "success");
      setAutoHideDuration(options.autoHideDuration || 3000);
    } else {
      setSeverity("success");
      setAutoHideDuration(3000);
    }

    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <SnackbarContext.Provider value={showSnackbar}>
      {children}
      <Snackbar
        open={open}
        autoHideDuration={autoHideDuration}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};

export const useSnackbar = () => {
  return useContext(SnackbarContext);
};
